/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React from 'react'
import { APP } from 'Configs/App'
import ReactDOM from 'react-dom'
import scriptLoader from 'react-async-script-loader'

import { PaypalButtonContainer } from './styles'

const style = {
  size: 'responsive',
  shape: 'pill',
  label: 'paypal',
  height: 40,
  tagline: false,
}

const CLIENT = {
  sandbox: APP.PAYPAL_CLIENT_KEY_SANDBOX,
  production: APP.PAYPAL_CLIENT_KEY_PRODUCTION,
}

class PaypalButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showButton: false,
    }
    window.React = React
    window.ReactDOM = ReactDOM
  }

  componentDidMount() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.setState({ showButton: true })
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isScriptLoaded, isScriptLoadSucceed } = nextProps
    const isLoadedButWasntLoadedBefore =
      // eslint-disable-next-line react/destructuring-assignment
      !this.state.showButton && !this.props.isScriptLoaded && isScriptLoaded
    if (isLoadedButWasntLoadedBefore) {
      if (isScriptLoadSucceed) {
        this.setState({ showButton: true })
      }
    }
  }

  render() {
    const {
      total,
      onSuccess,
      onClick,
      campaignId,
      price,
      onCancelPaypal,
    } = this.props

    const { showButton } = this.state
    const invoice_number = `SC-${campaignId}-${price && price.toFixed(2)}`
    const currency = 'USD'
    const transactionDescription = 'Campaign on SoundCampaign'

    const payment = () =>
      paypal.rest.payment.create(APP.paypal_environment, CLIENT, {
        transactions: [
          {
            amount: {
              total,
              currency,
            },
            description: transactionDescription,
            invoice_number,
            // campaign_value: price,
          },
        ],
      })
    const onAuthorize = (data, actions) => {
      actions.order.capture().then(details => {
        onSuccess(details)
      })
    }

    // eslint-disable-next-line no-console
    const onError = error => console.log('PayPal payment error', error)

    const onClickInner = () => {
      onClick()
    }

    const onCancelInner = () => {
      onCancelPaypal()
    }

    return (
      <PaypalButtonContainer>
        {showButton && (
          <paypal.Button.react
            client={CLIENT}
            commit
            env={APP.paypal_environment}
            payment={payment}
            style={style}
            onAuthorize={onAuthorize}
            onCancel={onCancelInner}
            onError={onError}
            onClick={onClickInner}
          />
        )}
      </PaypalButtonContainer>
    )
  }
}

export default scriptLoader('https://www.paypalobjects.com/api/checkout.js')(
  PaypalButton
)
